import { useCreateVrLessonWithVersion } from 'hooks/useCreateVrLessonWithVersion';
import { useCreateGameLessonWithVersion } from 'hooks/useCreateGameLessonWithVersion';
import { LessonForm } from "components/views/editor/models/LessonForm";
import { LessonType } from "models/LessonType";
import { GameEditorData } from "components/views/editor/gameEditor/models/GameEditorData";

export const useCreateLessonWithVersion = () => {
    const { createVrLessonWithVersion, isCreating: isCreatingVr } = useCreateVrLessonWithVersion();
    const { createGameLessonWithVersion, isCreating: isCreatingGame } = useCreateGameLessonWithVersion();

    const createLessonWithVersion = async (
        lessonFormData: LessonForm,
        currentLanguage: string,
        editor: any,
        gameEditorData?: GameEditorData
    ): Promise<string | null> => {
        switch (lessonFormData.lessonType) {
            case LessonType.GAME:
                if (!gameEditorData) return null;
                return createGameLessonWithVersion(lessonFormData, currentLanguage, gameEditorData);
            case LessonType.VR:
            default:
                return createVrLessonWithVersion(lessonFormData, currentLanguage, editor);
        }
    };

    return {
        createLessonWithVersion,
        isCreating: isCreatingVr || isCreatingGame
    };
};
